export const PREVIEW_SIZE_LOADING = 200;
export const PREVIEW_SIZE_IDLE = PREVIEW_SIZE_LOADING / 2;
export const PREVIEW_BORDER_WIDTH = 2;
export const PULSE_RING_SIZE = 240;
export const PULSE_RING_COUNT = 3;
export const PULSE_ANIMATION_DURATION_MS = 2400;
export const PULSE_ANIMATION_STAGGER_MS = 450;
export const PULSE_SCALE_START = 0.7;
export const PULSE_SCALE_END = 1.25;
